module.exports = __webpack_public_path__ + "img/no-trace.82e41c9e.svg";